import * as React from 'react';
import TheSelect from './index';
export default (props) => {
    const { input, input: { value }, meta: { error, touched }, options, multiple, ...restProps } = props;
    return (React.createElement(TheSelect, { ...input, onBlur: () => {
            input.onBlur(value);
        }, onFocus: input.onFocus, multiple: multiple, value: input.value ? input.value : multiple ? [] : null, error: touched && error ? error : undefined, options: options, ...restProps }));
};
